<template>
  <div>
    <video class="video" ref="player" @click="showGUI"></video>
    <div>
      <div
        v-show="jump == 'left'"
        class="seek-left"
        :style="{
          backgroundImage: 'url(' + require('@/assets/oval-ic.png') + ')',
        }"
      >
        <div class="seek-term left">-{{ seekTerm }}</div>
        <img class="seek-ic left" src="@/assets/ic-left.png" />
      </div>
      <div
        v-show="jump == 'right'"
        class="seek-right"
        :style="{
          backgroundImage: 'url(' + require('@/assets/oval-ic.png') + ')',
        }"
      >
        <div class="seek-term">+{{ seekTerm }}</div>
        <img class="seek-ic" src="@/assets/ic-right.png" />
      </div>
    </div>
    <transition name="slide-fade">
      <div v-if="show">
        <div @click="enterKeyProc" @mouseover="moveFocus(0)">
          <img
            v-if="focusIndex === 0"
            class="back"
            src="@/assets/vod-retrun-ic-f.png"
          />
          <img v-else class="back" src="@/assets/vod-retrun-ic-u.png" />
        </div>
        <template v-if="!isLive">
          <div @click="enterKeyProc" @mouseover="moveFocus(1)">
            <img
              v-if="focusIndex === 1"
              class="restart"
              src="@/assets/vod-before-ic-f.png"
            />
            <img v-else class="restart" src="@/assets/vod-before-ic-u.png" />
          </div>
        </template>
      </div>
    </transition>
    <transition name="slide-fade">
      <div v-if="show" class="pb-area">
        <div class="play-time">
          <span>{{ computedPlayPosition }}</span
          ><span v-if="!isLive">{{ computedPlayTime }}</span>
        </div>
        <div class="progressbar">
          <div class="innerbar" :style="innerBarStyle"></div>
          <div
            class="indicator"
            :style="indicatorStyle"
            @mousedown="mouseDragOn"
            @mouseup="mouseDragOff"
            v-show="mouseActivated"
          >
            <img src="@/assets/ball-indicator.png" />
          </div>
        </div>
        <div @click="enterKeyProc" @mouseover="moveFocus(2)">
          <template v-if="isPlaying">
            <img
              v-if="focusIndex === 2"
              class="play-pause pause"
              src="@/assets/stop-ic-f.png"
            />
            <img v-else class="play-pause pause" src="@/assets/stop-ic-u.png" />
          </template>
          <template v-else>
            <img
              v-if="focusIndex === 2"
              class="play-pause pause"
              src="@/assets/play-f.png"
            />
            <img v-else class="play-pause pause" src="@/assets/play-u.png" />
          </template>
        </div>
      </div>
    </transition>
    <div v-if="showPopup" class="exit-popup">
      <div class="dim"></div>
      <p class="pupup-message"> 홈 화면으로 이동합니다. </p>
      <button
        :class="{ focused: popupFocusIndex === 0 }"
        @click="historyBack"
        @mouseover="popupFocusIndex = 0"
        ref="button"
      >
        확인
      </button>
      <button
        :class="{ focused: popupFocusIndex === 1 }"
        @click="backKeyProc"
        @mouseover="popupFocusIndex = 1"
        ref="button"
      >
        취소
      </button>
    </div>
    <div class="movingboard" v-if="dragMode" @mouseup="mouseDragOff">
      <div
        class="active-area"
        @mouseup="mouseDragOff"
        @mousemove="mouseMove"
      ></div>
    </div>
  </div>
</template>

<script>
import * as deviceApi from "../api/smartTv.js";
import PlayerMixin from "../mixins/player.mixin"

export default {
  name: 'player',
  mixins: [PlayerMixin],
  props: ["contentType", "vodId"],
  data() {
    return {
      isActiveVue: true,
      focusIndex: 2,
      popupFocusIndex: 1,
      show: false,
      setVodComplete: false,
      isPlaying: false,
      playPostion: 0,
      playTime: 0,
      showPopup: false,
      dragMode: false,
      progressBarX: 0,
      indicatorX: 0,
      seekTerm: 5,
      jump: false,
      logStartTime: null,
      guiTimer: null,
      playInterval: null,
      logInterval: null,
      jumpIconTimer: null,
      popupTimer: null,
      deepLinkPlayerCheck: false
    };
  },
  computed: {
    isLive() {
      return this.contentType === 'live'
    },
    userInfo() {
      return this.$store.getters.userInfo;
    },
    lambdaInfo() {
      return this.$store.getters.lambdaInfo;
    },
    keyInput() {
      return this.$store.getters.keyInput;
    },
    mouseActivated() {
      return this.$store.getters.mouseActivated;
    },
    player() {
      return this.$refs.player;
    },
    source() {
      return this.$refs.source;
    },
    computedPlayPosition() {
      return this.convertTimeString(this.playPostion);
    },
    computedPlayTime() {
      return " / " + this.convertTimeString(this.playTime);
    },
    innerBarStyle() {
      return {
        width: this.progressBarX + "px",
      };
    },
    indicatorStyle() {
      return {
        left: this.indicatorX + "px",
      };
    },
    logViewApi() {
      return this.lambdaInfo.a_view;
    },
    logData() {
      return {
        age: this.userInfo.age,
        gender: this.userInfo.gender,
        os: deviceApi.getOsType() == "lg" ? "4" : "5",
        start: this.logStartTime,
        type: this.isLive ? "L" : "V",
        subType: this.userInfo.subType,
        serviceId: this.userInfo.serviceId,
        userId: this.userInfo.userId,
        videoId: this.vodId,
      };
    },
  },

  watch: {
    keyInput(val, oldVal) {
      if (this.isActiveVue) {
        switch (val.key) {
          case "ArrowUp":
            this.upKeyProc(val);
            break;
          case "ArrowDown":
            this.downKeyProc(val);
            break;
          case "ArrowLeft":
            this.leftKeyProc(val);
            break;
          case "ArrowRight":
            this.rightKeyProc(val);
            break;
          case "Enter":
            this.enterKeyProc(val);
            break;
          case "MediaPlayPause":
            this.playPauseKeyProc(val);
            break;
          case "Backspace":
            this.backKeyProc(val);
            return;
          default:
            return;
        }

        // if (this.showPopup == false) {
        //   this.showGUI();
        // }
      }
    },
    showPopup(val, oldVal) {
      if (val == true) {
        this.hideGUI();
        this.popupTimer = setTimeout(() => {
          this.showPopup = false;
        }, 60000);
      } else {
        this.clearPopupTimer();
      }
    },
  },

  methods: {
    upKeyProc(keyInput) {
      if (this.showPopup == false) {
        if (this.show == true) {
          switch (this.focusIndex) {
            case 2:
              this.focusIndex = 0;
              break;
          }
        }
        this.showGUI();
      }
    },
    downKeyProc(keyInput) {
      if (this.showPopup == false) {
        if (this.show == true) {
          switch (this.focusIndex) {
            case 0:
            case 1:
              this.focusIndex = 2;
              break;
          }
        }
        this.showGUI();
      }
    },
    leftKeyProc(keyInput) {
      if (this.showPopup === true) {
        this.popupFocusIndex = Math.abs(this.popupFocusIndex - 1);
        this.resetPopupTimer();
      } else {
        if (!this.isLive) {
          switch (this.focusIndex) {
            case 0:
              this.focusIndex = 1;
              break;
            case 1:
              this.focusIndex = 0;
              break;
            case 2:
              if (this.isPlaying) {
                this.seekTerm = 5;
                this.rew(this.seekTerm);
                this.showJumpIcon("left");
              }
              break;
          }
        }
        this.showGUI();
      }
    },
    rightKeyProc(keyInput) {
      if (this.showPopup === true) {
        this.popupFocusIndex = Math.abs(this.popupFocusIndex - 1);
        this.resetPopupTimer();
      } else {
        if (!this.isLive) {
          switch (this.focusIndex) {
            case 0:
              this.focusIndex = 1;
              break;
            case 1:
              this.focusIndex = 0;
              break;
            case 2:
              if (this.isPlaying) {
                this.seekTerm = 5;
                this.ff(this.seekTerm);
                this.showJumpIcon("right");
              }
              break;
          }
        }
        this.showGUI();
      }
    },
    enterKeyProc(keyInput) {
      if (this.showPopup === true) {
        switch (this.popupFocusIndex) {
          case 0:
            this.historyBack();
            break;
          case 1:
            this.showPopup = false;
            break;
        }
      } else {
        if (this.show == true) {
          switch (this.focusIndex) {
            case 0:
              this.backKeyProc();
              break;
            case 1:
              this.restart();
              break;
            case 2:
              this.playPause();
              break;
          }
        }
        this.showGUI();
      }
    },
    playPauseKeyProc(keyInput) {
      if (this.showPopup == false) {
        this.playPause();
        this.showGUI();
      }
    },
    backKeyProc(keyInput) {
      if (!this.isLive) {
        this.historyBack()
      } else {
        this.showPopup = !this.showPopup;
        this.hideGUI();
      }
    },

    moveFocus(index) {
      this.showGUI();
      this.focusIndex = index;
    },

    historyBack() {
      this.stop();
      if(this.deepLinkPlayerCheck) {
        this.$router.replace({
          name: "home",
          params: {
            t: new Date().getTime(),
          },
        });
      } else {
        this.$router.go(-1);
      }
    },
    mouseDragOn() {
      this.dragMode = true;
    },
    mouseDragOff() {
      this.dragMode = false;
      this.player.currentTime = Number(window.innerWidth) == 1920 ? (this.playTime * this.indicatorX) / 1680 : (this.playTime * this.indicatorX) / 1152;
      this.showGUI();
    },
    mouseMove(e) {
      this.indicatorX = e.offsetX;
    },
    start(url) {
      console.log("Starting playback");
      const self = this;
      /* Create listener object. */
      this.player.onerror = () => {
        console.log("Error! Something went wrong");
        this.onErrorEvent();
      };
      this.player.onloadstart = () => {
        console.log("Starting to load video");
        this.$progress.$emit("on:progress");
      };
      this.player.onloadeddata = () => {
        console.log("Browser has loaded the current frame");
      };
      this.player.oncanplay = () => {
        console.log("Can start playing video");
        self.play(!this.setVodComplete);
        this.setVodComplete = true;
      };
      this.player.onplay = () => {
        console.log("The video has started to play");
      };
      this.player.onplaying = () => {
        console.log("The video is now playing");
      };

      this.player.onended = () => {
        console.log("The video has ended");
        self.historyBack();
      };

      const source = document.createElement("source");
      let typeMediaOption = "";

      if (process.env.VUE_APP_OS_TYPE == "lg") {
        typeMediaOption = ";mediaOption=" + this.setMediaOption();
      }

      source.setAttribute("src", url)

      if (this.isLive) source.setAttribute("type", "application/vnd.apple.mpegurl" + typeMediaOption)
      else source.setAttribute("type", "video/mp4" + typeMediaOption)

      this.player.appendChild(source);
      this.checkPlayPostion();
      
      // this.sendViewLog();
    },

    setMediaOption() {
      const options = {};
      options.option = {};
      options.option.adaptiveStreaming = {};
      options.option.adaptiveStreaming.apativeResolution = true;
      options.option.adaptiveStreaming.seamlessPlay = true;

      return encodeURIComponent(JSON.stringify(options));
    },

    onErrorEvent() {
      this.stop();
      this.$router.replace({
        name: "err-api",
        params: {
          errorCode: this.player.error.code,
        },
      });
    },

    playPause() {
      if (this.player.paused) {
        this.play(true);
      } else {
        this.pause();
      }
    },

    play(sendLog) {
      console.log("VOD Playing!!!");
      this.$progress.$emit("off:progress");
      this.isPlaying = true;
      this.player.play();
      this.showGUI();
      if (sendLog) {
        this.sendViewLog();
      }
    },

    pause() {
      this.player.pause();
      this.isPlaying = false;
      this.clearLogInterval();
    },

    stop() {
      this.$progress.$emit("off:progress");
      this.clearAllTimer();
      this.pause();

      while (this.player.firstChild) {
        this.player.removeChild(this.player.firstChild);
      }
      // 명시적으로 load 호출하지 않으면 avplayer 전환 시 (samsung에서 live 재생 시) 이전 영상 노출 됨
      this.player.load()
    },

    restart() {
      this.player.currentTime = 0;
      this.play(true);
    },

    ff(sec) {
      this.player.currentTime = this.player.currentTime + sec;
    },

    rew(sec) {
      this.player.currentTime = this.player.currentTime - sec;
    },

    checkPlayPostion() {
      clearInterval(this.playInterval);

      this.playInterval = setInterval(() => {
        this.playPostion = this.player.currentTime;
        this.playTime = this.player.duration;

        if (this.isLive) {
          this.progressBarX = Number(window.innerWidth) == 1920 ? 1680 : 1152;
        } else {
          this.progressBarX = Number(window.innerWidth) == 1920 ? (this.playPostion / this.playTime) * 1680 : (this.playPostion / this.playTime) * 1152;
        }
        if (!this.dragMode) {
          this.indicatorX = this.progressBarX;
        }
      }, 200);
    },

    showGUI() {
      this.clearGuiTimer();
      this.show = true;
      this.guiTimer = setInterval(() => {
        if (this.dragMode === false) {
          this.hideGUI();
          this.hideJumpIcon();
        }
      }, 5000);
    },

    hideGUI() {
      this.clearGuiTimer();
      this.show = false;
      this.focusIndex = 2;
    },

    showJumpIcon(dirction) {
      this.jump = dirction;

      clearTimeout(this.jumpIconTimer);
      this.jumpIconTimer = null;

      this.jumpIconTimer = setTimeout(() => {
        this.hideJumpIcon();
      }, 5000);
    },

    hideJumpIcon() {
      clearTimeout(this.jumpIconTimer);
      this.jumpIconTimer = null;
      this.jump = false;
    },

    resetPopupTimer() {
      this.clearPopupTimer();
      this.popupTimer = setTimeout(() => {
        this.showPopup = false;
      }, 60000);
    },

    convertTimeString(sec) {
      let hour = sec >= 3600 ? parseInt(sec / 3600) : 0  // 낮은 소수점에서 간혹 시간 계산이 잘못 되는 경우 방지
      let min = parseInt((sec % 3600) / 60);
      let second = parseInt(sec % 60);
      if (Number.isNaN(min) || Number.isNaN(second)) {
        return "0:00:00";
      }

      if (min < 10) {
        min = "0" + min;
      }
      if (second < 10) {
        second = "0" + second;
      }
      
      return hour + ":" + min + ":" + second;
    },

    sendViewLog() {
      if (this.userInfo.userId == undefined) {
        console.log("invalid user");
        return;
      }

      const sender = (_data) => {
        this.$store
          .dispatch("SEND_VIEW_LOG", {
            url: this.logViewApi,
            data: _data,
          })
          .then((response) => {
            if (response.data) {
              this.logStartTime = response.data;
            }
          });
      };

      this.logStartTime = null;
      this.clearLogInterval();

      sender(this.logData);

      this.logInterval = setInterval(() => {
        sender(this.logData);
      }, 60 * 1000);
    },

    clearLogInterval() {
      clearInterval(this.logInterval);
      this.logInterval = null;
    },

    clearPlayInterval() {
      clearInterval(this.playInterval);
      this.playInterval = null;
    },

    clearGuiTimer() {
      clearTimeout(this.guiTimer);
      this.guiTimer = null;
    },

    clearPopupTimer() {
      clearTimeout(this.popupTimer);
      this.popupTimer = null;
    },

    clearAllTimer() {
      this.clearPlayInterval();
      this.clearLogInterval();
      this.clearGuiTimer();
      this.clearPopupTimer();
      this.hideJumpIcon();
    },
    callPaused(evt) {
      console.log(evt)
      // 현대자통차 이벤트 리스너
      if (evt.keyCode == 19 || evt.keyCode == 413) {
        this.pause()
      } else if (evt.keyCode == 415) {
        this.play(true);
      } else if (evt.keyCode == 417) {
        this.seekTerm = 5;
        this.ff(this.seekTerm);
        this.showJumpIcon("right");
      } else if (evt.keyCode == 412) {
        this.seekTerm = 5;
        this.rew(this.seekTerm);
        this.showJumpIcon("left");
      }
    }
  },

  created() {
    this.manifestLoader(this.vodId)

    if(sessionStorage.getItem("deepLink")) {
      this.deepLinkPlayerCheck = true
      sessionStorage.removeItem("deepLink") // LG DeepLink 값 제거
    }
  },
  mounted() {
    document.addEventListener('keyup', this.callPaused);
  },
  beforeDestroy() {
    this.isActiveVue = false;
    this.stop();
    // this.unload()
    document.removeEventListener('keyup', this.callPaused);
    this.$progress.$emit("offLiveStatus");
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
    this.stop();
    this.$progress.$emit("offLiveStatus");
    // this.unload()
  },
};
</script>
<style scoped>
input {
  border: none;
}
.video {
  position: absolute;
  left: 0;
  height: 0;
  width: 1920px;
  height: 1080px;
}
.back {
  position: absolute;
  width: 72px;
  height: 72px;
  left: 120px;
  top: 78px;
}
.restart {
  position: absolute;
  width: 72px;
  height: 72px;
  left: 232px;
  top: 78px;
}
.pb-area {
  position: absolute;
  width: 1920px;
  height: 540px;
  top: 540px;
  left: 0;
  background-image: linear-gradient(to bottom, rgba(17, 17, 17, 0), #111111);
}
.play-pause {
  position: absolute;
  width: 120px;
  height: 120px;
  left: 900px;
  top: 366px;
}
.play-time {
  position: absolute;
  right: 120px;
  top: 254px;

  font-size: 40px;
  line-height: 0.8;
  color: #eeeeee;
}
.progressbar {
  position: absolute;
  width: 1680px;
  height: 16px;
  left: 120px;
  top: 318px;
  background-color: #595959;
}
.innerbar {
  height: 16px;
  background-color: #2affcc;
}
.indicator {
  position: absolute;
  left: 0;
  width: 40px;
  height: 40px;
  margin-left: -20px;
  margin-top: -28px;
}
.movingboard {
  position: absolute;
  left: 0px;
  right: 0px;
  width: 1920px;
  height: 1080px;
  z-index: 5;
}
.active-area {
  position: absolute;
  width: 1680px;
  height: 1080px;
  left: 120px;
  bottom: 0;
  /* background-color: cornflowerblue; */
  /* opacity: 0.5; */
}
.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(100px);
  opacity: 0;
}
.exit-popup {
  position: absolute;
  left: 0;
  top: 0;
  width: 1920px;
  height: 1080px;
  text-align: center;
}
.dim {
  position: absolute;
  left: 0;
  top: 0;
  width: 1920px;
  height: 1080px;
  opacity: 0.8;
  background-color: #1e1e1e;
}
.pupup-message {
  margin-top: 432px;
  font-size: 56px;
  line-height: 1;
  text-align: center;
  color: #eeeeee;
}
button {
  width: 272px;
  height: 80px;
  background-color: #3e3e3e;
  font-size: 28px;
  color: #eeeeee;
  margin-top: 80px;
  margin-right: 27px;
  border: none;
}
button.focused {
  border: solid 4px #eeeeee;
}
.seek-left {
  position: absolute;
  left: 555px;
  top: 460px;
  width: 120px;
  height: 120px;
}
.seek-right {
  position: absolute;
  left: 1246px;
  top: 460px;
  width: 120px;
  height: 120px;
}
.seek-term {
  position: absolute;
  left: 19px;
  top: 22px;
  width: 78px;
  height: 86px;
  line-height: 86px;
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  color: #eeeeee;
}
.seek-ic {
  position: absolute;
  left: 19px;
  top: 17px;
}
.seek-term.left {
  left: 24px;
}
.seek-ic.left {
  left: 24px;
}

@media all and (min-width:0px) and (max-width:1280px){
  .video {
    width: 100vw;
    height: 100vh;
  }

  .back {
    position: absolute;
    width: 48px;
    height: 48px;
    left: 64px;
    top: 48px;
  }
  .restart {
    position: absolute;
    width: 48px;
    height: 48px;
    left: 136px;
    top: 48px;
  }

  .pb-area {
    position: absolute;
    width: 100%;
    height: 360px;
    top: 360px;
    left: 0;
    background-image: linear-gradient(to bottom, rgba(17, 17, 17, 0), #111111);
  }

  .play-pause {
    position: absolute;
    width: 80px;
    height: 80px;
    left: 600px;
    top: 248px;
  }
  .play-time {
    position: absolute;
    right: 64px;
    top: 168px;
    font-size: 26px;
    line-height: 1;
    color: #eeeeee;
  }
  .progressbar {
    position: absolute;
    width: 1152px;
    height: 8px;
    left: 64px;
    top: 208px;
    background-color: #595959;
  }
  .innerbar {
    height: 8px;
    background-color: #2affcc;
  }

  .seek-left {
    position: absolute;
    left: 280px;
    top: 300px;
    width: 120px;
    height: 120px;
  }
  .seek-right {
    position: absolute;
    left: 880px;
    top: 300px;
    width: 120px;
    height: 120px;
  }

  .exit-popup {
    position: absolute;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    text-align: center;
  }

  .dim {
    position: absolute;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    opacity: 0.8;
    background-color: #1e1e1e;
  }
  .pupup-message {
    margin-top: 292px;
    font-size: 32px;
    line-height: 1;
    text-align: center;
    color: #ffffff;
  }

  button {
    width: 160px;
    height: 56px;
    background-color: #3e3e3e;
    font-size: 18px;
    font-weight: bold;
    color: #ffffff;
    margin-top: 80px;
    margin-right: 16px;
    border: none;
  }
  button.focused {
    border: solid 3px #eeeeee;
  }

  .indicator {
    /* position: absolute;
    left: 0;
    width: 40px;
    height: 40px;
    margin-left: -20px;
    margin-top: -28px; */
    display: none;
  }
}
</style>